import { EpipProcessingStatusCode } from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementPage/types';
import { TranslationType } from '../../HbtIndividualLoanDetails/types';

export const statusMapper = (t: TranslationType) => {
  const mapping: Record<EpipProcessingStatusCode, string> = {
    [EpipProcessingStatusCode.RECEIVED]: t('PI-Portfolio-Status-Mapping-R'),
    [EpipProcessingStatusCode.VALIDATION_IN_PROGRESS]: t('PI-Portfolio-Status-Mapping-VIP'),
    [EpipProcessingStatusCode.VALIDATION_COMPLETED]: t('PI-Portfolio-Status-Mapping-VC'),
    [EpipProcessingStatusCode.READY_FOR_CREDIT_BUREAU]: t('PI-Portfolio-Status-Mapping-RFCB'),
    [EpipProcessingStatusCode.FILE_READY_FOR_CREDIT_BUREAU]: t('PI-Portfolio-Status-Mapping-FRCB'),
    [EpipProcessingStatusCode.SENT_TO_CREDIT_BUREAU]: t('PI-Portfolio-Status-Mapping-STCB'),
    [EpipProcessingStatusCode.RECEIVED_FROM_CREDIT_BUREAU]: t('PI-Portfolio-Status-Mapping-REFCB'),
    [EpipProcessingStatusCode.SENT_TO_EPIP]: t('PI-Portfolio-Status-Mapping-STMPI'),
    [EpipProcessingStatusCode.DELETED]: t('PI-Portfolio-Status-Mapping-D'),
    [EpipProcessingStatusCode.MANUAL]: t('PI-Portfolio-Status-Mapping-M'),
    [EpipProcessingStatusCode.READY_TO_CANCEL]: t('PI-Portfolio-Status-Mapping-RTC'),
    [EpipProcessingStatusCode.CANCELLATION_COMPLETED]: t('PI-Portfolio-Status-Mapping-CC')
  };

  const getLabel = (code: string): string => {
    return mapping[code as EpipProcessingStatusCode] ?? t('Unknown');
  };

  return {
    getLabel,
    mapping
  };
};
